import React from 'react';
import '../../styles/layout.css';

/**
 * GridContainerElement - Visual CSS Grid with configurable rows/columns
 * Shows dotted grid lines, cells are drop targets
 */
const GridContainerElement = ({ element, children, isEditorMode }) => {
  const { props } = element;
  const {
    rows = 2,
    columns = 2,
    gap = 'medium',
    minRowHeight = '100px',
    backgroundColor = 'transparent'
  } = props || {};

  const style = {
    display: 'grid',
    gridTemplateRows: `repeat(${rows}, auto)`,
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    '--grid-rows': rows,
    '--grid-columns': columns
  };

  if (backgroundColor && backgroundColor !== 'transparent') {
    style.backgroundColor = backgroundColor;
  }

  return (
    <div
      className={`grid-container ${isEditorMode ? 'grid-editor-mode' : ''}`}
      data-gap={gap}
      data-rows={rows}
      data-columns={columns}
      style={style}
    >
      {children}
    </div>
  );
};

export default GridContainerElement;
